<usb-base-item [item]="item" [styleSidebar]="styleSidebar" [currencyAgency]="currencyAgency" [currencies]="currencies" [clientsSettingAppBooking]="clientsSettingAppBooking" (openMap)="openMap.emit($event)">
  <ng-container *ngFor="let room of item.rooms; let i = index">
    <hr class="w-100 p-0 mb-3" style="border: none; border-top: 2px solid #000000;" />

    <div class="d-flex flex-column detail-item mb-4">
      <!-- Status and Remove -->
      <div *ngIf="item.rooms.length > 1" class="d-flex justify-content-end align-items-start w-100 mb-3">
        <div class="d-flex flex-column justify-content-between mr-3" style="margin-top: 10px;">
          <span [class]="'status status-sidebar ' + getStatusHotelClass(room.status_id)">
            {{ room.status }}
          </span>
        </div>

        <ng-container *ngIf="room.status_id === 1 || room.status_id === 2">
          <button
            class="d-flex align-items-center justify-content-center py-1 px-1"
            style="border-bottom-left-radius: 10px; border: none; background-color: #facad3; width: 35px; height: 35px;"
          >
            <!-- Cancel icon for "Reservado" rooms (statusId 2). The cart-sidebar
                 parent already routes the click to cancelReservation. -->
            <div
              *ngIf="room.status_id === 2"
              class="item-button"
              (click)="onRemoveItem(room)"
              title="cancel"
            >
              <img
                src="../../../../../../assets/icons/itinerary-detail/04-01.svg"
                alt="cancel"
                style="
                  width: 20px;
                  filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                "
              />
            </div>

            <!-- Default trash icon for rooms in "Cotización" (statusId 1) -->
            <div
              *ngIf="room.status_id === 1"
              class="item-button"
              (click)="onRemoveItem(room)"
              title="delete"
            >
              <svg version="1.1" id="Layer_2_00000146472910104976704670000005604375476625682068_"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                style="fill: #ff3f63; width: 20px;" xml:space="preserve">
                <path d="M422.1,82H388V53c0-29.3-23.7-53-53-53H177c-29.3,0-53,23.7-53,53v29H90c-18.8,0-34.1,15.3-34.1,34.1v54.6
                  c0,9.4,7.6,17.1,17.1,17.1l0,0h10.3v273c0,28.3,22.9,51.2,51.2,51.2h243.2c28.3,0,51.2-22.9,51.2-51.2V187.7h10.4
                  c9.4,0,17.1-7.6,17.1-17c0,0,0,0,0,0v-54.5C456.2,97.3,440.9,82,422.1,82z M158.1,53c0-10.4,8.5-18.9,18.9-18.9h158
                  c10.4,0,18.9,8.4,18.9,18.9v29H158.1V53z M89.9,116.1h332.2v37.5H89.9V116.1z M394.7,460.8c0,9.4-7.6,17.1-17.1,17.1H134.4
                  c-9.4,0-17.1-7.6-17.1-17.1V187.7h277.3V460.8z"/>
                <path d="M170.7,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5s-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                  C153.6,439.4,161.3,447,170.7,447z"/>
                <path d="M256,447c9.4,0,17-7.6,17.1-17V235.6c0-9.4-7.6-17.1-17.1-17.1c-9.4,0-17.1,7.6-17.1,17.1V430C239,439.4,246.6,447,256,447z
                  "/>
                <path d="M341.3,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5c-9.4-0.2-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                  C324.3,439.4,331.9,447,341.3,447z"/>
              </svg>
            </div>
          </button>
        </ng-container>
      </div>

      <!-- Room Type -->
      <div class="d-flex flex-column mb-3">
        <p
          style="
            font-family: 'Rubik';
            font-size: 14px;
            font-weight: 600;
            line-height: 1.2;
            text-transform: none;
          "
          class="m-0"
        >
          {{room.roomType}}
        </p>
        <p
          *ngIf="room.boardName"
          style="
            font-family: 'Rubik';
            font-size: 14px;
            font-weight: 600;
            line-height: 1.2;
            text-transform: none;
          "
          class="m-0"
        >
          {{room.boardName}}
        </p>
      </div>

      <div class="mb-2">
        <span *ngIf="room.rateClassId === 'R' || room.rateClass === 'R' || room?.pricing?.rateClass === 'R'" class="px-2 py-1" style="font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1; color: #34c26d; background-color: #defef4; text-transform: none; border-radius: 6px;">Reembolsable</span>
        <span *ngIf="room.rateClassId === 'NR' || room.rateClass === 'NR' || room?.pricing?.rateClass === 'NR'" class="px-2 py-1" style="font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1; color: #ed3b5b; background-color: #fde6ea; text-transform: none; border-radius: 6px;">No Reembolsable</span>
      </div>

      <!-- NIGHTS -->
      <div class="mb-3">
        <p
          class="hotel-room m-0 mt-1"
          style="
            font-family: 'Rubik';
            text-transform: none;
            display: flex;
            align-items: center;
            width: 100%;
            text-transform: none;
            font-size: 14px;
            color: #000000;
          "
        >
          {{ getNights(room) }} {{ getNights(room) === 1 ? "Noche" : "Noches" }}
        </p>
      </div>

      <!-- Room Information -->
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center" style="gap: 2px;">
          <img width="20" height="20" src="../../../../../../assets/icons/search-result/hotel/HABITACION.svg"/>
          <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">1 Habitación</span>
        </div>
        <div class="d-flex align-items-center" style="gap: 2px;">
          <img width="20" height="20" src="../../../../../../assets/icons/itinerary/persona.svg"/>
          <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">{{ room.adults }} {{ room.adults === 1 ? 'Adulto' : 'Adultos' }}</span>
        </div>
        <div class="d-flex align-items-center" style="gap: 2px;">
          <img width="20" height="20" src="../../../../../../assets/icons/search-result/hotel/NIÑO.svg"/>
          <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">{{ room.childrens }} {{ room.childrens === 1 ? 'Niño' : 'Niños' }}</span>
        </div>
      </div>

      <!-- DATE CHECK IN - OUT -->
      <div class="hotel-date font-poppins m-0 mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column align-items-start" style="color: #000000;">
            <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none; line-height: 1.2;">Check In:</span>
            <p *ngIf="room.arrivalDate" class="mb-0" style="font-size: 14px; font-family: 'Rubik'; font-weight: 500; text-transform: none; line-height: 1.2;">
              {{ room?.arrivalDate | date: "EEE. dd MMM yyyy" }}
            </p>
            <p *ngIf="room?.checkTimes?.checkIn" class="mb-0" style="font-size: 13px; font-family: 'Rubik'; font-weight: 400; text-transform: none; line-height: 1.2;">
              {{ room?.checkTimes?.checkIn && room.checkTimes.checkIn.trim() ? room.checkTimes.checkIn : "n/a" }}
            </p>
          </div>

          <div class="d-flex flex-column align-items-start" style="color: #000000;">
            <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none; line-height: 1.2;">Check Out:</span>
            <p *ngIf="room.departureDate" class="mb-0" style="font-size: 14px; font-family: 'Rubik'; font-weight: 500; text-transform: none; line-height: 1.2;">
              {{ room?.departureDate | date: "EEE. dd MMM yyyy" }}
            </p>
            <p *ngIf="room?.checkTimes?.checkOut" class="mb-0" style="font-size: 13px; font-family: 'Rubik'; font-weight: 400; text-transform: none; line-height: 1.2;">
              {{ room?.checkTimes?.checkOut && room.checkTimes.checkOut.trim() ? room.checkTimes.checkOut : "n/a" }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="mr-3"
      >
        <p
          class="m-0"
          style="
            font-family: 'Muli', sans-serif;
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            text-transform: none;
          "
        >
          Tarifa Habitación:
        </p>
        <div class="d-flex justify-content-start align-items-center" style="gap: 1px;">
          <p
            class="m-0"
            style="
              font-family: 'Rubik', sans-serif;
              font-size: 14px;
              font-weight: 600;
              line-height: 1.2
            ">
            {{ currencyAgency?.code }}
            <span *ngIf="(room?.statusId || room?.status_id) !== 5">{{ getRoomDisplayPrice(room) | number: "1.2-2" }}</span>
            <span *ngIf="(room?.statusId || room?.status_id) === 5">{{ 0 | number: "1.2-2" }}</span>
          </p>
          <usb-tooltip-convert-amount
            *ngIf="(room?.statusId || room?.status_id) !== 5"
            [clientsSettingAppBooking]="clientsSettingAppBooking"
            [currencyProduct]="currencyAgency?.code"
            [valueProduct]="getRoomDisplayPrice(room)">
          </usb-tooltip-convert-amount>
        </div>

        <div
          *ngIf="room?.currency !== currencyAgency?.code && (room?.statusId || room?.status_id) !== 5"
          class="d-flex justify-content-start flex-column"
        >
          <p
            class="mb-0"
            style="font-family: 'Rubik', sans-serif; font-size: 13px; font-weight: 500; line-height: 1.2;"
          >
            {{ room?.currency }} {{ (room?.netPriceAgent + (room?.room?.pricing?.taxesExcluded || 0)) | number: "1.2-2" }}
          </p>

          <span style="font-family: 'Muli', sans-serif; font-size: 10px; font-weight: 400; line-height: 1.2; text-transform: none;">
            impuestos incluidos
          </span>
        </div>
      </div>

    </div>

  </ng-container>
</usb-base-item>
